angular.module("Khayrokom") .
controller ("HomeController" ,
    ['modalService','$scope','$cookies','$translate','callService','$rootScope','$window','$filter','Notification','$state','$q','$controller',
    function(modalService,$scope,$cookies,$translate,callService,$rootScope,$window,$filter,Notification,$state,$q,$controller){
        $controller('MainController', {$scope: $scope})
        $scope.initHomePage=function(){
            $scope.test=false;
        $scope.fristTime=false;
        $scope.banners=[];
        $rootScope.temlate=0;
        $rootScope.id=0;
        $rootScope.theBestVideo = 'adOVMWbUmnY';
        $rootScope.index=0;
        var now = new Date(),
            exp = new Date(now.getFullYear()+100, now.getMonth(), now.getDate());
        if($cookies.get('titleArticle')!=undefined){
            $scope.titleArticle=$cookies.get('titleArticle');
            $scope.htmlBody=$cookies.get('htmlBody');
        }
        if($cookies.get('lang')==undefined)
        {
            $scope.arabic=true;
            $cookies.put('lang','ar',{expires: exp})

        }
        else if($cookies.get('lang')=='ar'){
            $translate.use('ar');
            $scope.arabic=true;
            $cookies.put('lang','ar',{expires: exp})
        }
        else {
            $scope.arabic=false;
            $translate.use('en');
            $cookies.put('lang','en',{expires: exp})
        }

        $scope.getHomePage().then(function () {
            $scope.fristTime=true;
        });

    }
        $scope.testTrue=function () {
            $scope.test=true;
        }
        $scope.testFalse=function () {
            $scope.test=false;
        }

        // it just change the language but as Yu-Gi-Oh!
        $scope.changeOfHeart=function (input) {

            var now = new Date(),
                exp = new Date(now.getFullYear()+100, now.getMonth(), now.getDate());
            var flag=false;
            if($cookies.get('lang')!=input){
                flag=true;
                $state.go('home')
            }
            if(input=="en"){
                $cookies.put('lang','en',{expires: exp})
                $translate.use('en');
                $scope.arabic=false;
            }
            else{
                $cookies.put('lang','ar',{expires: exp})
                $translate.use('ar');
                $scope.arabic=true;
            }
            if(flag&&(!$state.includes('staff')&&!$state.includes('bio'))){
                $scope.banners=[];
                $scope.partners=[];
                $rootScope.services=[];
                $rootScope.videos=[];
                $rootScope.news=[];
                $scope.statistics=[];

                $scope.getHomePage()
            }
            else if (flag&&($state.includes('staff')||$state.includes('bio'))){
                $rootScope.stuff=[]
                $scope.teachingStuff();
            }
            if(flag){
                $state.reload();
            }
        };
        $scope.home=function () {
            if($scope.fristTime){
               $scope.getHomePage()
            }

        }
        $scope.setTemplate=function (input,id) {
            var now = new Date(),
                exp = new Date(now.getFullYear()+100, now.getMonth(), now.getDate());


            var arr=['a','b','c','d'];
            $rootScope.temlate=arr.indexOf(input);
            $rootScope.index=$rootScope.services.map(function(e) { return e.id; }).indexOf(id);

            $cookies.put('id',id,{expires: exp});
            $cookies.put('index',$rootScope.index,{expires: exp});
            $cookies.put('temlate',$rootScope.temlate,{expires: exp})

        }
        $scope.getHomePage=function () {
            var q = $q.defer();
            var json={}
            json.url='api/home-page'
            callService.ajaxCall(json).then(function (data) {
                if(data.data.banners!=undefined)
                for(var i=0;i<data.data.banners.length;i++){
                    if(data.data.banners[i].image!="")
                        data.data.banners[i].image='http://khairokom.gplanet.tech/uploads/'+data.data.banners[i].image
                    else
                        data.data.banners[i].image= require('../../imgs/private-courses.png')
                }

                if(data.data.news!=undefined)
                    for(var i=0;i<data.data.news.length;i++){
                        if(data.data.news[i].image!="")
                            data.data.news[i].image='http://khairokom.gplanet.tech/uploads/'+data.data.news[i].image
                        else
                            data.data.news[i].image=require('../../imgs/news-2.png');
                    }if(data.data.partners!=undefined)
                    for(var i=0;i<data.data.partners.length;i++){
                        if(data.data.partners[i].image!="")
                            data.data.partners[i].image='http://khairokom.gplanet.tech/uploads/'+data.data.partners[i].image
                        else
                            data.data.partners[i].image=require('../../imgs/news-2.png');
                    }
                if(data.data.videos!=undefined){
                    for(var i=0;i<data.data.videos.length;i++){
                        if(data.data.videos[i].image!="")
                            data.data.videos[i].image='http://khairokom.gplanet.tech/uploads/'+data.data.videos[i].image
                        else
                            data.data.videos[i].image=require('../../imgs/video-1.jpg');
                    }
                    var kLimit=1;
                    if(data.data.videos.length>4){
                        $scope.rowVideos={val:[[],[]]}
                        var kLimit=2;
                    }
                    else
                        $scope.rowVideos={val:[[]]}


                    for(var k=0;k<kLimit;k++){
                            for(var i=0 ;i<data.data.videos.length;i++){
                                if(i==4)
                                    k++
                                if(i==8)
                                    break;
                                $scope.rowVideos.val[k].push(data.data.videos[i])
                            }
                        }

                    if(data.data.services.length%4!=0)
                        var jLimit= Math.floor(data.data.videos.length/4)+1;
                    else
                        var jLimit= Math.floor(data.data.videos.length/4);

                    $scope.allRowVideos={val:[]}
                    for(var i=0;i<jLimit;i++)
                        $scope.allRowVideos.val.push([]);
                    for(var j=0;j<jLimit;j++){
                        for(var i=0 ;i<data.data.videos.length;i++){
                            if(i%4==0&&i!=0)
                                j++
                            $scope.allRowVideos.val[j].push(data.data.videos[i])
                        }
                    }

                }
                if(data.data.services!=undefined){
                    for(var i=0;i<data.data.services.length;i++){
                        if(data.data.services[i].image!="")
                            data.data.services[i].image='http://khairokom.gplanet.tech/uploads/'+data.data.services[i].image
                        else
                            data.data.services[i].image=require('../../imgs/service-7.png');
                    }
                    if(data.data.services.length%4!=0)
                        var jLimit= Math.floor(data.data.services.length/4)+1;
                    else
                        var jLimit= Math.floor(data.data.services.length/4);
                    $scope.rowServices={val:[]}
                    for(var i=0;i<jLimit;i++)
                        $scope.rowServices.val.push([]);
                    var j=0
                        for(var i=0 ;i<data.data.services.length;i++){
                            if(i%4==0&&i!=0)
                                j++;
                            $scope.rowServices.val[j].push(data.data.services[i])
                    }
                }
                if (data.data.footer!= undefined) {
                    if (data.data.footer.length % 4 != 0)
                        var jLimit = Math.floor(data.data.footer.length / 4) + 1;
                    else
                        var jLimit = Math.floor(data.data.footer.length / 4);
                    $scope.rowFooters = {val:[]}
                    for (var i = 0; i < jLimit; i++)
                        $scope.rowFooters.val.push([]);
                    var j = 0
                    for (var i = 0; i < data.data.footer.length; i++) {
                        if (i % 4 == 0 && i != 0)
                            j++;
                        $scope.rowFooters.val[j].push(data.data.footer[i])
                    }
                }
                $scope.banners=data.data.banners;
                $scope.partners=data.data.partners;
                $rootScope.services=data.data.services;
                $rootScope.videos=data.data.videos;
                $rootScope.news=data.data.news;
                $scope.statistics=data.data.statistics;
                q.resolve();
            })
            return q.promise;
        };
        $rootScope.getVideoComments=function (videoId,serviceId) {
            var json = {};
            json.url = 'api/video-comments';
            json.data = {};
            json.data.videoId= videoId;
            if(serviceId!=undefined)
                json.data.serviceId= serviceId;
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                if(data.data.length!=undefined){
                for(var i=0;i<data.data.length;i++){

                        var date=new Date(data.data[i].created_at.split(' ')[0])
                    data.data[i].created_at=date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()
                }
                }
                $rootScope.vedioComments=data.data
            })
        }
        $rootScope.addVideoComments=function (videoId,serviceId) {
            var json = {};
            json.url = 'api/add-video-comment';
            json.data = {};
            json.data.videoId= videoId;
            if(serviceId!=undefined)
                json.data.serviceId= serviceId;
            try{
                if($scope.emailComment==""||$scope.emailComment.trim().length==0){
                    Notification.warning({message: $filter('translate')('EMPTY_EMAIL'), delay: 5000});
                    return
                }
            }catch (s){}
            try{
                if($scope.name==""||$scope.name.trim().length==0){
                    Notification.warning({message: $filter('translate')('EMPTY_NAME'), delay: 5000});
                    return
                }
            }catch (s){}
            try{
                if($scope.comment==""||$scope.comment.trim().length==0){
                    Notification.warning({message: $filter('translate')('EMPTY_COMMENT'), delay: 5000});
                    return
                }
            }catch (s){}
            if(!($scope.emailComment.includes("@")&&$scope.emailComment.includes(".")&&$scope.emailComment.length>=5)){
                Notification.warning({message: $filter('translate')('ERROR_EMAIL'), delay: 5000});
                return
            }
            json.data.body=$scope.comment;
            json.data.name=$scope.name;
            json.data.email=$scope.emailComment;
            json.method = 'POST';
            callService.ajaxCall(json).then(function (data) {
                var date=new Date();
                if($rootScope.vedioComments!=undefined)
                $rootScope.vedioComments.push({
                    name:$scope.name,
                    body:$scope.comment,
                    created_at:date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()
                })

                else {
                    $rootScope.vedioComments=[]
                    $rootScope.vedioComments.push({
                        name:$scope.name,
                        body:$scope.comment,
                        created_at:date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()
                    })
                }
                $scope.comment='';
                $scope.name='';
                $scope.emailComment='';
            })
        }
        $rootScope.openVedioModal = function (input,videoId,serviceId) {
            /*try{$scope.theBestVideo=input.split('watch?v=')[1]}
            catch (s){}*/
            $rootScope.theBestVideo=input;
            $rootScope.videoId=videoId;
            if(serviceId!=undefined)
                $rootScope.serviceId=serviceId;
            $rootScope.comment="";
            $rootScope.name="";
            $rootScope.emailComment="";
            var modalInstance = modalService.createModal(
                require('../../views/modals/videoModal.html'),
                'HomeController', $rootScope);
            modalService.setCurrentModal(modalInstance);
            $rootScope.vedioModal=true;
            $rootScope.getVideoComments(videoId,serviceId);
        };
        $rootScope.openNews=function (input) {
            if(input.split("http://")[1]==undefined){
            $window.open("http://"+input);
            }
            else{
                $window.open(input);
            }
        }
        $scope.closeModal = function () {
            var modalInstance = modalService.getCurrentModal();
            modalInstance.close();
            $rootScope.vedioModal=false;
            $rootScope.codeModal=false;
        };
        $scope.openNewsArticle=function (title,body) {
            $scope.titleArticle=title;
            $scope.htmlBody=body;
            var now = new Date(),
                exp = new Date(now.getFullYear()+100, now.getMonth(), now.getDate());

            $cookies.put('titleArticle',title,{expires: exp})
            $cookies.put('htmlBody',body,{expires: exp})
            $state.go('article')
            $window.scrollTo(0, 0);
        }
        $scope.getFooterLinks=function () {
            var json={}
            json.url='api/footer-links'
            callService.ajaxCall(json).then(function (data) {

            })
        }
    }]);



// WEBPACK FOOTER //
// ./js/controllers/HomeController.js